import { Box, Grid2, Typography } from '@mui/material'
import Tier3KPIsNew from './Tier3KPIsNew'

export default function KPIPyramidNew() {

    return (
        <Grid2 sx={{
            position: 'relative',
            width: '100%',
            boxSizing: 'border-box',
        }}>
            <svg width="100%" height="100%" viewBox="0 0 1400 600" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M466.282 27.3874C470.843 21.5815 479.198 21.5301 483.822 27.2796L562.207 124.747C568.604 132.702 563.306 145 553.478 145H398.521C388.757 145 383.436 132.838 389.708 124.855L466.282 27.3874Z" fill="#666666" />
                <path d="M468.413 28.1314C472.651 22.6642 480.415 22.6159 484.712 28.0298L562.404 125.929C568.349 133.42 563.425 145 554.294 145H400.706C391.633 145 386.688 133.548 392.516 126.031L468.413 28.1314Z" stroke="url(#paint0_linear_3_2)" strokeOpacity="0.5" strokeWidth="1.14833" />
                <path d="M356.646 172.201C358.828 169.53 361.979 168 365.291 168H593.545C596.939 168 600.161 169.608 602.344 172.392L669.282 257.751C675.568 265.766 670.252 278 660.483 278H295.517C285.638 278 280.36 265.524 286.872 257.559L356.646 172.201Z" fill="#666666" />
                <path d="M356.362 172.886C358.405 170.416 361.355 169 364.454 169H592.378C595.555 169 598.57 170.487 600.616 173.063L667.456 257.272C673.34 264.686 668.363 276 659.219 276H294.781C285.533 276 280.594 264.462 286.687 257.095L356.362 172.886Z" stroke="url(#paint1_linear_3_2)" strokeOpacity="0.5" strokeWidth="1.14833" />
                <path d="M271.672 298C267.72 298 263.951 299.781 261.304 302.902L181.367 397.115C171.6 408.627 179.283 427 193.865 427H758.135C773.202 427 780.679 407.564 769.93 396.336L692.5 303.5C690.5 301 688 298 679.859 298H271.672Z" fill="url(#paint2_linear_3_2)" fillOpacity="0.2" stroke="#41D9E1" strokeWidth="4" />
                <path d="M145.31 446.917C147.486 443.815 150.832 442 154.378 442H794.792C798.236 442 801.498 443.712 803.679 446.666L899.38 576.213C905.519 584.521 900.183 597 890.493 597H63.5062C53.9506 597 48.5742 584.824 54.4383 576.464L94.3957 519.5L145.31 446.917Z" fill="#666666" />
                <path d="M146.206 447.597C148.247 444.697 151.385 443 154.711 443H795.456C798.687 443 801.746 444.601 803.791 447.362L899.543 576.563C905.3 584.332 900.296 596 891.206 596H63.7927C54.8297 596 49.7866 584.615 55.2872 576.798L95.2651 519.986L146.206 447.597Z" stroke="url(#paint3_linear_3_2)" strokeOpacity="0.5" strokeWidth="1.14833" />
                <path d="M729.5 349L964 346" stroke="url(#paint4_linear_3_2)" strokeWidth="4" />
                <defs>
                    <linearGradient id="paint0_linear_3_2" x1="375.65" y1="16.7273" x2="398.721" y2="81.1226" gradientUnits="userSpaceOnUse">
                        <stop stopColor="white" stopOpacity="0.5" />
                        <stop offset="1" stopColor="white" stopOpacity="0.1" />
                    </linearGradient>
                    <linearGradient id="paint1_linear_3_2" x1="268.169" y1="168.431" x2="276.958" y2="228.135" gradientUnits="userSpaceOnUse">
                        <stop stopColor="white" stopOpacity="0.5" />
                        <stop offset="1" stopColor="white" stopOpacity="0.1" />
                    </linearGradient>
                    <linearGradient id="paint2_linear_3_2" x1="733.316" y1="362.406" x2="252.671" y2="351.838" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#18FEFE" stopOpacity="0.3" />
                        <stop offset="1" stopColor="#18FEFE" />
                    </linearGradient>
                    <linearGradient id="paint3_linear_3_2" x1="37.5721" y1="442.478" x2="46.1153" y2="528.522" gradientUnits="userSpaceOnUse">
                        <stop stopColor="white" stopOpacity="0.5" />
                        <stop offset="1" stopColor="white" stopOpacity="0.1" />
                    </linearGradient>
                    <linearGradient id="paint4_linear_3_2" x1="734.321" y1="365.846" x2="901.094" y2="363.65" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#41D9E1" />
                        <stop offset="1" />
                    </linearGradient>
                </defs>
            </svg>


            <Grid2 sx={{
                boxSizing: 'border-box',
                position: 'absolute',
                top: 0,
                width: '100%',
                height: '100%',
                zIndex: 1,
                display: 'grid',
                gridTemplateColumns: '68% 30%',
            }}>
                <Grid2 sx={{
                    width: '100%',
                    height: '100%',
                    display: 'grid',
                    textAlign: 'center',
                    gridTemplateRows: '24% 23.5% 25% 27.5%',
                    '& > div': {
                        position: 'relative',
                        zIndex: 1,
                        display: 'grid',
                        placeContent: 'center',
                        color: '#C1C1C1',
                        '&.coming_soon::after': {
                            content: '"Coming\\ASoon"',
                            whiteSpace: 'pre',
                            position: 'absolute',
                            top: 0,
                            width: '100%',
                            height: '100%',
                            backdropFilter: 'saturate(100%) blur(0.125vw)',
                            display: 'grid',
                            placeContent: 'center',
                            fontSize: '2rem',
                            fontWeight: 'bold',
                            lineHeight: 1,
                            color: 'var(--text-light)'
                        },
                    },
                    '& > div:first-of-type': {
                        boxSizing: 'border-box',
                        paddingTop: '2rem',
                        '&::after': {
                            fontSize: '1.125rem',
                            paddingTop: '1.25rem'
                        }
                    },
                    '& > div:nth-of-type(2)': {
                        '&::after': {
                            fontSize: '1.5rem',
                        }
                    }
                }}>
                    <Box className="coming_soon">
                        <Typography fontSize={'1rem'} lineHeight={1}>
                            Tier 1
                            <br /> process
                            <br /> safety
                            <br /> events
                        </Typography>
                    </Box>
                    <Box className="coming_soon">
                        <Typography variant='h6' lineHeight={1}>
                            Tier 2
                            <br />
                            process safety events
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant='h6' color='var(--text-dark)'>Tier 3</Typography>
                        <Typography variant='h6' color='var(--text-dark)' fontWeight={500}>Challenges to safety systems</Typography>
                    </Box>
                    <Box className="coming_soon">
                        <Typography variant='h6' lineHeight={1}>
                            Tier 4 process safety KPIs
                        </Typography>
                    </Box>
                </Grid2>
                <Grid2 sx={{
                    boxSizing: 'border-box',
                }}>
                    <Tier3KPIsNew></Tier3KPIsNew>
                </Grid2>
            </Grid2>

            <Grid2 sx={{
                position: 'absolute',
                zIndex: 1,
                top: 0,
                left: '0.5%',
                width: '30%',
                height: '100%',
            }}>
                <svg width="100%" height="100%" viewBox="0 0 401 514" fill="none">
                    <path d="M397.773 2.2131C397.606 0.831377 396.371 -0.151108 395.015 0.0191619L372.911 2.79181C371.554 2.96093 370.59 4.21953 370.757 5.60125C370.924 6.98413 372.159 7.96665 373.515 7.79638L393.164 5.33207L395.582 25.3503C395.749 26.732 396.984 27.7145 398.34 27.5454C399.697 27.3752 400.661 26.1165 400.494 24.7348L397.773 2.2131ZM221.901 232.906L397.268 4.07342L393.367 0.969441L218 229.804L221.901 232.906Z" fill="url(#paint0_linear_30_23)" />
                    <path d="M2.85373 511.446C3.02765 512.892 4.31404 513.92 5.72699 513.742L28.7522 510.84C30.1651 510.663 31.1695 509.346 30.9957 507.9C30.8217 506.453 29.5354 505.424 28.1224 505.602L7.65552 508.182L5.13629 487.23C4.96237 485.784 3.67597 484.756 2.26303 484.933C0.85009 485.111 -0.154343 486.428 0.0195725 487.874L2.85373 511.446ZM186.054 270L3.38037 509.499L7.44378 512.748L190.118 273.247L186.054 270Z" fill="url(#paint1_linear_30_23)" />
                    <defs>
                        <linearGradient id="paint0_linear_30_23" x1="220.395" y1="231.709" x2="399.851" y2="6.12854" gradientUnits="userSpaceOnUse">
                            <stop stopColor="#009CA4" stopOpacity="0.2" />
                            <stop offset="1" stopColor="#009CA4" />
                        </linearGradient>
                        <linearGradient id="paint1_linear_30_23" x1="187.623" y1="271.253" x2="-0.39579" y2="506.481" gradientUnits="userSpaceOnUse">
                            <stop stopColor="#009CA4" stopOpacity="0.2" />
                            <stop offset="1" stopColor="#009CA4" />
                        </linearGradient>
                    </defs>
                </svg>

                <Box sx={{
                    width: '135%',
                    position: 'absolute',
                    top: '45%',
                    left: '-22.5%',
                    display: 'flex',
                    justifyContent: 'space-between',
                    transform: 'rotate(-52.5deg)'
                }}>
                    <Typography variant='h6' color='#009CA4'>Leading Indicators</Typography>
                    <Typography variant='h6' color='#009CA4'>Lagging Indicators</Typography>
                </Box>
            </Grid2>
        </Grid2>
    )
}

